import { JetView } from "webix-jet";
import palette from "helpers/palette";

export default class UsersView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;

		return {
			view: "form",
			localId: "form",
			scroll: "auto",
			margin: 20,
			css: "webix_um_edit_form",
			elementsConfig: {
				labelWidth: 130,
				labelAlign: "right",
			},
			rows: [
				{
					margin: 10,
					cols: [
						{},
						{
							view: "button",
							width: 120,
							label: _("Delete"),
							click: () => this.Delete(),
						},
						{
							width: 120,
							value: _("Save"),
							view: "button",
							css: "webix_primary",
							click: () => this.Save(),
						},
					],
				},
				{
					view: "text",
					label: _("Name"),
					name: "name",
					localId: "focus",
					inputWidth: 370,
				},
				{
					view: "colorpicker",
					label: _("Color"),
					name: "color",
					inputWidth: 370,
					suggest: {
						type: "colorboard",
						padding: 3,
						body: {
							view: "colorboard",
							palette,
							width: 8 * 29,
							height: 2 * 29,
						},
					},
				},
				{},
			],
		};
	}

	urlChange() {
		webix.delay(() => this.$$("focus").focus());
		this.ID = this.getParam("id", true);
		if (this.ID) {
			const data = this.app.getService("local").roles(true);
			data.waitData.then(() => {
				const role = data.getItem(this.ID);
				this.$$("form").setValues(role);
			});
		}
	}

	Save() {
		if (this.ID) {
			let roleData = this.$$("form").getValues();

			this.app.getService("operations").updateRole(this.ID, roleData);
		}
	}

	Delete() {
		const _ = this.app.getService("locale")._;
		webix
			.confirm({
				title: _("Delete"),
				ok: _("Delete"),
				cancel: _("Cancel"),
				text: _("Are you sure to delete this role ?"),
			})
			.then(() => {
				this.app.getService("operations").deleteRole(this.ID);
				this.app.show("/top/roles/_hidden");
			});
	}
}
